module.exports = __webpack_public_path__ + "img/ao.e57c6e57.png";